module.exports = __webpack_public_path__ + "img/wifiapcredentials.c241e2a8.png";